import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import useDeletionStatus from '../../hooks/useDeletionStatus';
import AccountDeletionPending from '../AccountDeletionPending/AccountDeletionPending';

const DeletionGuard = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const { status: deletionStatus, loading } = useDeletionStatus();

  // Дозволені маршрути для користувачів з запитом на видалення
  const allowedPaths = [
    '/uk/gdpr-dashboard',
    '/en/gdpr-dashboard',
    '/gdpr-dashboard'
  ];

  useEffect(() => {
    // Якщо користувач запросив видалення і не на дозволеній сторінці
    if (deletionStatus?.deletionRequested) {
      const isOnAllowedPath = allowedPaths.some(path => 
        location.pathname === path || location.pathname.endsWith(path)
      );

      if (!isOnAllowedPath) {
        console.log('🚫 DeletionGuard: Redirecting user with deletion request');
        window.location.replace('/uk/gdpr-dashboard');
        return;
      }
    }
  }, [deletionStatus, location.pathname]);

  // Не показуємо лоадер, просто швидко перевіряємо статус у фоні
  if (loading) {
    return children; // Показуємо контент одразу, перевірка йде у фоні
  }

  // Якщо користувач запросив видалення і на GDPR сторінці, показуємо спеціальний компонент
  if (deletionStatus?.deletionRequested && allowedPaths.some(path => 
    location.pathname === path || location.pathname.endsWith(path)
  )) {
    return <AccountDeletionPending />;
  }

  // Інакше показуємо звичайний контент
  return children;
};

export default DeletionGuard;